import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TherapyService } from '../../therapy-tab/therapy.service';

@Component({
  selector: 'app-note-sidebar-rehab-diagnosis',
  templateUrl: './note-sidebar-rehab-diagnosis.component.html',
  styleUrls: ['./note-sidebar-rehab-diagnosis.component.css']
})
export class NoteSidebarRehabDiagnosisComponent implements OnInit {
  
  dataSource: any = new MatTableDataSource([]);
  loaderId = 'app-note-sidebar-rehab-diagnosis';
  timeoutId: any;
  @Input() noteId: any;
  @Input() noteText: any;
  @Input() selectedDiagnoses: any;
  @Output() checkboxStateChange = new EventEmitter<any>();
  icdGroups: any = [];
  displayedColumns: string[] = ['code', 'checkbox'];
  
  constructor(
    private loader: NgxUiLoaderService,
    private therapyService : TherapyService

  ) { }

  async ngOnInit() {
    await this.getRehabDiagnosisSuggestions();
  }

  async getRehabDiagnosisSuggestions() {
    return new Promise<void>((resolve, reject) => {
      this.loader.startLoader(this.loaderId);
      this.therapyService.getRehabDiagnosisSuggestions(this.noteId).subscribe((response: any) => {
        if (response.status == 200 && response.data) {
          if (response.data.length === 1) {
            this.icdGroups = response.data[0].suggestions;
            this.icdGroups.forEach(element => {
              if (element.icd.end_date) {
                const [month, day, year] = element.icd.end_date.split("/");
                if (moment(`${year}-${month}-${day}`).isBefore(moment())) {
                  element.icd.isExpired = true;
                }
              }
              console.log('hello',this.icdGroups);
              return element;
            });
            this.icdGroups = this.icdGroups.filter(icd => icd.isExpired == undefined)
          }
          this.loader.stopLoader(this.loaderId);
          resolve();
        }
        else {
          resolve();
          this.loader.stopLoader(this.loaderId);

        }
      }, err => {
        this.loader.stopLoader(this.loaderId);
        reject();
      }
      );
    });    
  }

  onCheckboxChange($event, icd) {
    this.checkboxStateChange.emit(icd);
  }

  isChecked(ele) {
    if (Array.isArray(this.selectedDiagnoses)) {
      const index = this.selectedDiagnoses.findIndex(icd => icd._id == ele._id);
      if (index > -1) {
        ele.selected = true;
        return true;
      }
      return false
    }
  }
}
